<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="名称">
        <el-input placeholder="请输入名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input placeholder="请输入地址" v-model="filter.address" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否投运">
        <el-select class="selScale" v-model="filter.is_operation">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="是" value="true"> </el-option>
          <el-option label="否" value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button icon="el-icon-plus" type="success" @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="站点名" prop="name"></el-table-column>
      <el-table-column label="是否投运" prop="status_name" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.is_operation">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="地址" prop="address"></el-table-column> -->
      <el-table-column label="所属社区" prop="community_name"></el-table-column>
      <el-table-column label="纬度" prop="gps_lat"></el-table-column>
      <el-table-column label="经度" prop="gps_lng"></el-table-column>
      <el-table-column label="场地类型" prop="place_type">
        <template slot-scope="{ row }">
          {{ getPlaceTypeName(row.place_type) }}
        </template>
      </el-table-column>
      <el-table-column label="站点图片" prop="pic_json">
        <template slot-scope="{ row }">
          <el-image v-if="getFirstImageUrl(row.pic_json)" class="station-img" :src="getFirstImageUrl(row.pic_json)" fit="cover" :preview-src-list="getAllImageUrls(row.pic_json)"> </el-image>
          <span v-else>无图片</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text" @click="editChargingConfig(row)" v-permision_tjtf="'model'">计费模型</el-button>
          <el-button type="text" @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增or修改街道 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="站点名" prop="name" label-width="20%">
              <el-input placeholder="请输入站点名" v-model="form.name" maxlength="30" />
            </el-form-item>
            <el-form-item label="地址" prop="address" label-width="20%">
              <el-input placeholder="请输入地址" v-model="form.address" />
            </el-form-item>
            <el-form-item label="所属社区" prop="community_id" label-width="20%">
              <el-select v-model="form.community_id" placeholder="请选择所属社区" style="width: 100%" clearable filterable>
                <el-option v-for="item in communityOptions" :key="item.ID" :label="item.name" :value="item.ID">
                  <span style="float: left">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="纬度" prop="gps_lat" label-width="20%">
              <el-input placeholder="请输入纬度" v-model="form.gps_lat" />
            </el-form-item>
            <el-form-item label="经度" prop="gps_lng" label-width="20%">
              <el-input placeholder="请输入经度" v-model="form.gps_lng" />
            </el-form-item>
            <el-form-item label="场地类型" prop="place_type" label-width="20%">
              <el-select v-model="form.place_type" placeholder="请选择场地类型" style="width: 100%" clearable>
                <el-option v-for="item in placeTypeOptions" :key="item.value" :label="item.name" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否投运" label-width="20%">
              <el-switch v-model="form.is_operation" active-text="是" inactive-text="否" />
            </el-form-item>
            <el-form-item label="站点图片" prop="pic_json" label-width="20%">
              <file-upload listType="picture-card" :limit="100" @fileChange="fileChange" field="pic_json" :fileList="form.pic_json"></file-upload>
            </el-form-item>
            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input placeholder="请输入备注" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>

    <!-- 时间段计费模型 -->
    <charging-config :show.sync="visible.costModel" @confirm="getModelId" :params="modelParams" :type="seletType" :billingModel="billingModel"></charging-config>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import chargingConfig from "./components/charging-config.vue"
import { getPowerSiteList, modifyPowerSite, delPowerSite, addPowerSite, getCommunityList } from "@/api/dev_archive"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload, chargingConfig },
  data() {
    return {
      visible: {
        editGroup: false,
        costModel: false
      },
      uploadhandlerimgs: "",
      placeTypeOptions: [
        { name: "小区", value: 1 },
        { name: "公共用地", value: 2 },
        { name: "厂区", value: 3 },
        { name: "办公楼", value: 4 },
        { name: "超市", value: 5 }
      ],
      tableData: [],
      form: {
        name: "",
        address: "",
        remark: "",
        community_id: "",
        gps_lat: "",
        gps_lng: "",
        place_type: "",
        is_operation: true,
        pic_json: []
      },
      seletType: {},
      billingModel: "powersite",
      modelParams: {},
      communityOptions: [],
      formRules: {},
      filter: {
        name: "",
        address: "",
        is_operation: ""
      },
      loading: false,
      isUpdate: true,
      gid: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {
      name: [{ required: true, message: "请输入站点名", trigger: "blur" }],
      address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      gps_lat: [{ required: true, message: "请输入纬度", trigger: "blur" }],
      gps_lng: [{ required: true, message: "请输入经度", trigger: "blur" }],
      place_type: [{ required: true, message: "请选择场地类型", trigger: "change" }],
      community_id: [{ required: true, message: "请选择所属社区", trigger: "change" }]
    }

    this.loadCommunityOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    getPlaceTypeName(value) {
      const option = this.placeTypeOptions.find((item) => item.value == value)
      return option ? option.name : value
    },

    getModelId() {
      this.getData()
    },

    editChargingConfig(row) {
      this.seletType = row
      this.modelParams = { charging_config_id: row.charging_config_id, power_site_id: row.ID }
      this.visible.costModel = true
    },

    fileChange(fileList, field) {
      this.uploadhandlerimgs = ""
      this.form[field] = fileList
      fileList.forEach((d) => {
        this.uploadhandlerimgs += d.url + ","
      })
    },

    getFirstImageUrl(picJsonString) {
      if (!picJsonString) return null

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            const validPics = picArray.filter((pic) => pic.path && pic.path.trim() !== "")
            if (validPics.length > 0) {
              return validPics[0].path
            }
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          if (urls.length > 0) {
            return urls[0].trim()
          }
        }
        return null
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        if (urls.length > 0) {
          return urls[0].trim()
        }
        return null
      }
    },

    getAllImageUrls(picJsonString) {
      if (!picJsonString) return []

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            return picArray.filter((pic) => pic.path && pic.path.trim() !== "").map((pic) => pic.path)
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          return urls.map((url) => url.trim())
        }
        return []
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        return urls.map((url) => url.trim())
      }
    },

    loadCommunityOptions() {
      return getCommunityList()
        .then((res) => {
          if (res && res.data) {
            this.communityOptions = res.data.filter((item) => !item.del)
            return this.communityOptions
          }
          return []
        })
        .catch((error) => {
          this.$message.error("加载社区列表失败")
          return []
        })
    },

    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true

      if (!this.communityOptions.length) {
        await this.loadCommunityOptions()
      }

      this.form.name = row.name
      this.form.address = row.address
      this.form.community_id = row.community_id
      this.form.gps_lat = row.gps_lat
      this.form.gps_lng = row.gps_lng
      this.form.place_type = row.place_type
      this.form.remark = row.remark
      this.gid = row.ID
      this.form.is_operation = row.is_operation

      if (row.pic_json) {
        try {
          if (row.pic_json.startsWith("[") || row.pic_json.startsWith("{")) {
            const picArray = JSON.parse(row.pic_json)
            if (Array.isArray(picArray)) {
              this.form.pic_json = picArray.map((item) => ({
                ...item,
                url: item.path,
                name: item.name || `image_${item.id || Date.now()}`,
                path: item.path,
                size: item.size || 0
              }))
            } else {
              this.form.pic_json = []
            }
          } else {
            const urls = row.pic_json
              .replace(/^,|,$/g, "")
              .split(",")
              .filter((url) => url.trim() !== "")
            this.form.pic_json = urls.map((url, index) => ({
              url: url.trim(),
              name: `image_${index + 1}`,
              path: url.trim(),
              size: 0
            }))
          }
        } catch (error) {
          const urls = row.pic_json
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          this.form.pic_json = urls.map((url, index) => ({
            url: url.trim(),
            name: `image_${index + 1}`,
            path: url.trim(),
            size: 0
          }))
        }
      } else {
        this.form.pic_json = []
      }
    },

    async onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false

      this.form = {
        name: "",
        address: "",
        remark: "",
        community_id: "",
        gps_lat: "",
        gps_lng: "",
        place_type: "",
        is_operation: true,
        pic_json: []
      }

      if (!this.communityOptions.length) {
        await this.loadCommunityOptions()
      }
    },

    onDelete(row) {
      this.$confirm("确定要删除该站点吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delPowerSite(row).then(() => {
            this.$message.success(`删除成功`)
            this.toFilter()
          })
        })
        .catch(() => {})
    },

    getData() {
      this.loading = true
      getPowerSiteList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        ...this.filter
      })
        .then((res) => {
          const communityMap = {}
          this.communityOptions.forEach((community) => {
            communityMap[community.ID] = community.name
          })

          this.tableData = res.data.map((item) => {
            return {
              ...item,
              community_name: communityMap[item.community_id] || item.community_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()

          if (this.uploadhandlerimgs.endsWith(",")) {
            this.uploadhandlerimgs = this.uploadhandlerimgs.slice(0, -1)
          }

          const reqData = {
            name: this.form.name,
            address: this.form.address,
            community_id: this.form.community_id,
            gps_lat: this.form.gps_lat,
            gps_lng: this.form.gps_lng,
            place_type: this.form.place_type,
            pic_json: this.uploadhandlerimgs,
            is_operation: this.form.is_operation,
            remark: this.form.remark
          }

          if (this.isUpdate) {
            reqData.ID = this.gid
            modifyPowerSite(reqData)
              .then(() => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .catch(() => {
                //this.$message.error("修改失败")
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addPowerSite(reqData)
              .then(() => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .catch(() => {
                //this.$message.error("添加失败")
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.station-img {
  width: 50px;
  height: 50px;
}
</style>
